"use client";
import {
  Card
} from "./chunk-C7FBNCT2.mjs";
import {
  Button_default
} from "./chunk-CGHW2YLJ.mjs";

// src/components/sections/FeatureLine/FeatureLine.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function FeatureLine({
  referId,
  title,
  cards,
  buttons
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      id: referId,
      className: "flex justify-center items-center py-40 lg:py-80 px-24",
      children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col justify-center items-center w-full max-w-[455px] md:max-w-[950px]", children: [
        /* @__PURE__ */ jsx(
          "h2",
          {
            dangerouslySetInnerHTML: {
              __html: title
            },
            className: "font-display text-center text-4xl font-semibold"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-16 justify-center md:justify-between p-16 md:p-40 mt-16 md:mt-24 w-full rounded-2xl border-2 border-stone-500", children: cards == null ? void 0 : cards.map((props, index) => /* @__PURE__ */ jsx("div", { className: "flex", children: /* @__PURE__ */ jsx(Card, { ...props }) }, index)) }),
        buttons.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-col md:flex-row gap-16 md:gap-24 mt-24 w-full md:w-max", children: buttons == null ? void 0 : buttons.map((props, index) => /* @__PURE__ */ jsx(
          Button_default,
          {
            ...props,
            className: "w-full md:w-max"
          },
          `${props.children}-${index}`
        )) })
      ] })
    }
  );
}

export {
  FeatureLine
};
